import type { ScorecardsResult } from '@recruitee/interview-results-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<ScorecardsResult[]>()(
  'InterviewResultsScorecards',
  {
    customActions: adapter => ({
      fetch: (state, payload: { candidateId: number; offerId?: number }) =>
        adapter.markAsPending(state),
    }),
  },
);

export {
  actions as InterviewResultsScorecardsActions,
  selectors as InterviewResultsScorecardsSelectors,
  reducer as InterviewResultsScorecardsReducer,
  namespace as InterviewResultsScorecardsNamespace,
};
